import React from 'react';

const Footer = () => {
  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-gray-800 bg-opacity-40 py-2 z-10">
      <div className="container mx-auto">
        <p className="text-white text-right">© 2023 Your Website. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
